import { cn } from "@/lib/utils";
import { useTheme } from "@/lib/theme";
import { useSettings } from "@/lib/settings";
import { imageSrc } from "@/lib/images";

/**
 * Mahano mark — the real "M" logo, alternating between the ink artwork on light
 * surfaces and the ivory artwork on dark ones. A workspace that uploads its own
 * icon (Settings → Branding) overrides it. Filename kept so imports still work.
 */
export default function HaloRing({ className = "", size = 32, spin = false, tone }) {
  const { theme } = useTheme();
  const { settings } = useSettings() || {};
  const custom = settings?.brand_icon_url;
  const src = custom
    ? imageSrc(custom)
    : (tone || theme) === "dark" ? "/brand/mark-on-dark.png" : "/brand/mark-on-light.png";
  return (
    <span className={cn("halo-ring", spin && "animate-pulse", className)}
          style={{ width: size, height: size }} aria-hidden="true">
      <img src={src} alt="" className="h-full w-full object-contain" draggable="false" />
    </span>
  );
}
